/**
 * AndVSunburst - 旭日图组件
 * 基于 Ant Design Charts Sunburst
 */
import React from 'react';
import { Sunburst } from '@ant-design/plots';
import { withBaseChart } from '../base/BaseChart';
import type { AndVSunburstProps } from '../base/types';

const DEFAULT_SUNBURST_DATA = {
  name: '分类',
  children: [
    {
      name: '华东',
      value: 40,
      children: [
        { name: '上海', value: 18 },
        { name: '杭州', value: 12 },
        { name: '南京', value: 10 },
      ],
    },
    {
      name: '华南',
      value: 35,
      children: [
        { name: '广州', value: 20 },
        { name: '深圳', value: 15 },
      ],
    },
    {
      name: '华北',
      value: 25,
      children: [
        { name: '北京', value: 15 },
        { name: '天津', value: 10 },
      ],
    },
  ],
};

const SunburstWithBase = withBaseChart<AndVSunburstProps>(Sunburst, {
  chartType: 'AndVSunburst',
  defaultHeight: 300,
  defaultData: DEFAULT_SUNBURST_DATA,
});

export const AndVSunburst: React.FC<AndVSunburstProps> = (props) => {
  const { valueField, colorField, ...baseProps } = props;

  const chartProps: Record<string, unknown> = { ...baseProps };

  if (valueField) chartProps.valueField = valueField;
  if (colorField) chartProps.colorField = colorField;

  return <SunburstWithBase {...chartProps} />;
};

export type { AndVSunburstProps };
export default AndVSunburst;
